<template>
  <img
    class="object-contain w-full"
    :class="[
      $attrs.class ? $attrs.class : 'h-5'
    ]"
    alt="SenangPay logo"
    src="@/assets/image/logo-razer.png"
  />
</template>